import React from 'react';
import { NavigateFunction } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { di } from '../../../state/inversify.config';
import { AccountTypes } from '../../../components/changeUser/accountTypes.enum';
import { AddPlayerDomain, NewPlayerInputs } from '../addPlayer.domain';
import { AddPlayer } from './addPlayer';
import { PlayerCreatePayload } from '../../../state/reduxRepositories/players/player.interfaces';
import { AlertDialog } from '../../../components/alertDialog/alertDialog';

interface AddPlayerModalProps {
  showAddPlayerModal: boolean;
  setShowAddPlayerModal: (value: boolean) => void;
  onClose: () => void;
  dispatchCreatePlayer: (
    newPlayer: PlayerCreatePayload,
    navigator: NavigateFunction,
    emailToConneqtWith?: string,
  ) => void;
  initialValues?: NewPlayerInputs;
}
export function AddPlayerModal({
  showAddPlayerModal,
  onClose,
  dispatchCreatePlayer,
  setShowAddPlayerModal,
  initialValues,
}: AddPlayerModalProps) {
  const { t } = useTranslation();

  const addPlayerDomain = di.get(AddPlayerDomain);
  const accountType = addPlayerDomain.useAccountTypeSelector();

  return (
    <AlertDialog
      title={
        accountType === AccountTypes.Clinic
          ? t('ADD_PATIENT').toString()
          : t('ADD_PLAYER').toString()
      }
      open={showAddPlayerModal}
      setOpen={setShowAddPlayerModal}
      content={
        <AddPlayer
          dispatchCreatePlayer={dispatchCreatePlayer}
          closeModal={setShowAddPlayerModal}
          initialValues={initialValues}
        />
      }
    />
  );
}
